import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Star } from 'lucide-react';

export default function About() {
  const { t } = useLanguage();

  return (
    <section
      data-testid="about-section"
      className="section-padding bg-[#FBF9F6]"
    >
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative overflow-hidden group">
            <img
              src="https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/0blq05ul_WhatsApp%20Image%202026-04-17%20at%2012.21.52%20%281%29.jpeg"
              alt="Rui's Restaurante Exterior"
              className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2A1E17]/20 to-transparent" />
          </div>

          {/* Content */}
          <div className="space-y-6">
            <p className="overline">{t('about.overline')}</p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#2A1E17] leading-tight">
              {t('about.title')}
            </h2>
            <div className="w-20 h-[2px] bg-[#8C5A2B]" />
            <p className="text-[#6B584B] text-base md:text-lg leading-relaxed">
              {t('about.description')}
            </p>
            
            {/* Rating */}
            <div className="flex items-center gap-3 pt-4">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={20}
                    fill={i < 4 ? '#8C5A2B' : 'none'}
                    stroke={i < 4 ? '#8C5A2B' : '#8C5A2B'}
                    strokeWidth={1.5}
                  />
                ))}
              </div>
              <span className="text-[#2A1E17] font-medium">{t('about.rating')}</span>
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              {[
                { icon: '🍷', text: 'Great Wine List' },
                { icon: '☕', text: 'Great Coffee' },
                { icon: '🍰', text: 'Great Desserts' },
                { icon: '🥩', text: 'Premium Steaks' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-[#6B584B]">
                  <span className="text-xl">{item.icon}</span>
                  <span className="text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
